// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

import React from 'react';
import styled from 'styled-components';
import TopHeader from '../common/topHeader';
import ScrollButton from './top/backToTop/ScrollButton';

const Title = styled.div`
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0.1em;
  line-height: 30px;
  margin-bottom: 40px;
  color: #464646;
  text-align: center;

  @media screen and (max-width: 768px) {
    font-size: 16px;
    line-height: 28px;
    margin-bottom: 20px;
  }
`;

const Content = styled.div`
  font-size: 14px;
  letter-spacing: 0.1em;
  line-height: 24px;
  margin-bottom: 30px;
  color: #464646;

  @media screen and (max-width: 768px) {
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 15px;
  }
`;

export default function Terms() {
  return (
    <>
      <TopHeader title="「くじロード」利用規約" />
      <div className="main-content form-static">
        <Title>「くじロード」利用規約</Title>
        <Content>
          「くじロード」利用規約（以下「本規約」といいます。）は、株式会社ブシロードクリエイティブ（以下「当社」といいます。）が提供する、本サービスの利用に関する条件を定めるものです。本サービスの利用については、本規約をお読みいただくとともに、本規約に同意のうえ、ご利用ください。なお、未成年者の方は、本サービスをご利用いただくことができません。
        </Content>
        <Content>
          第１条（定義）
          <br />
          本規約で使用する用語の意味は、以下のとおりとします。
          <br />
          １．「登録者」とは、「くじロード」の利用を希望するユーザー様が本規約に同意いただいた上で、当社所定の手続に従い本サービスの登録画面から登録を申請し、当社がこれを承認した方をいいます。
          <br />
          ２．「本サイト」とは、当社が運営するインターネット・サイト「くじロード」をいいます。
          <br />
          ３．「本サービス」とは、当社が本サイトにおいて提供する、当社が別途定める企画内容に応じたくじ（以下「くじ」といいます。）を販売し、当該くじの結果として当選した商品を提供するサービス及びこれに付随するサービスをいいます。
          <br />
          ４．「登録情報」とは、登録者が当社に提供した個人情報等の情報をいいます。
          <br />
          ５．「商品」とは、本サービスにおけるくじの結果として当選した商品その他の当社から登録者に提供する商品をいいます。
          <br />
        </Content>
        <Content>
          第２条（本規約の適用）
          <br />
          １．本規約は、本サービスの提供条件及び本サービスの利用に関する当社と登録者との間の権利義務関係を定めることを目的とし、本サービスの利用に係る一切の関係に適用されるものとします。
          <br />
          ２．登録者は、本規約のほか、当社が定める各種の規定（以下「個別規定」といいます。）に同意し、本サービスを利用するものとします。なお、本規約と個別規定（以下、総称して「本規約等」といいます。）の定めが異なる場合には、個別規定の定めが優先するものとします。
        </Content>

        <Content>
          第３条（本サービスの利用及び責任）
          <br />
          １．登録者は、本規約等に従い、登録者自身の自己責任において本サービスを利用するものとし、当社に何らの不利益、負担又は損害を与えないものとします。
          <br />
          ２．登録者は、本サービスの利用のために必要となるプロバイダ料金、回線利用料、通信費等を全て自己負担するものとします。
          <br />
          ３．登録者は、登録者の責めに帰すべき事由により、当社又は第三者に損害が生じた場合、全ての責任を負うものとします。
        </Content>

        <Content>
          第４条（登録）
          <br />
          １．登録希望者は、本サービスの登録ページから、別途当社の指定する方法に従い、当社が別途定める登録情報を入力の上、登録申請を行うものとします。その後の、当社からの登録完了の通知をもって登録完了とし、本サービスの利用に係る登録者と当社との契約（以下「利用契約」といいます。）が成立するものとします。なお、登録完了までにはお時間がかかる場合がございます。
          <br />
          ２．当社は、以下の各号のいずれかに該当する場合、登録希望者の登録を拒み又は登録者の登録を取消すことができるものとします。
          <br />
          （１）本規約等に違反するおそれがある場合
          <br />
          （２）登録希望者が過去に登録の取消等の処分を受けていることが判明した場合
          <br />
          （３）登録希望者の申請内容に事実に反する事項が含まれている場合
          <br />
          （４）登録希望者が反社会的勢力等（暴力団、暴力団員、暴力団準構成員、暴力団関係企
          <br />
          業、総会屋、社会運動標ぼうゴロ、政治活動標ぼうゴロ、特殊知能暴力集団又はこれらの者と密接な関わりを有する者若しくはこれらに準じる者）のいずれかと、何らかの交流若しくは関与があると当社が判断した場合
          <br />
          （５）登録希望者が日本国内に住所を有していない場合
          <br />
          （６）登録希望者が未成年である場合
          <br />
          （７）その他登録希望者の登録申請を承認することが不適当であると当社が判断する場合
        </Content>

        <Content>
          第５条（くじの購入）
          <br />
          １．登録者は、本サービスを利用して、くじを購入するものとします。登録者は、本サイトにおいて表示される「くじ」そのものは登録者に提供される商品又はサービス等（以下「商品等」といいます。）を決定するためのものであり、「くじ」自体が別途提供される商品等ではないことを理解した上で購入するものとします。
          <br />
          ２．くじの購入に関する契約（以下「購入契約」といいます。）は、当社が、決済完了メール（登録情報に登録されたメールアドレス宛に｢【くじロード】ご注文ありがとうございます。｣の件名で送信されます。）を登録者に送信した時点で成立するものとします。
          <br />
          なお、当社は、購入契約成立前にご注文をお断りすることがあります。
          <br />
          ３．当社は、個別のサービス画面又はご利用ガイドその他の本サービス上の画面において定めがある場合を除き、登録者都合によるくじの購入申込の撤回は一切受け付けないものとします。
          <br />
          ４．当社では、商品等の価格を正確に掲載するよう努力いたします。万が一誤った価格が掲載され、その情報に基づきご注文をいただいた場合、当社は、発送完了メール送信までに当社から変更の通知を行い、改めて変更後の価格でその注文の意思を確認させていただきます。
          <br />
          ５．本サービス利用において、登録者が、本規約等に違反する行為を行った場合、又は当社が配送した商品等を、理由の如何を問わず登録者が受領しなかった場合（登録者が代金を支払い済みの場合を含みます。）、当社は購入契約の解除、その他適切な措置を取ることができるものとします。
          この場合に当社に生じた費用（商品等の配送料その他手数料を含みますが、これらに限りません。）は登録者の負担とします。
        </Content>

        <Content>
          第６条（商品の選択について）
          <br />
          １．商品を選択できるくじの場合、登録者は、購入契約の成立後に当選した商品について、当社が別途定める方法により、商品の選択（以下「商品選択」といいます。）を行なうものとします。
          <br />
          ２．理由のいかんを問わず、ブラウザを閉じる、または不正終了等により、登録者が正しく商品選択を行わなかった場合、当社は、登録者に対し、メールにより正しく商品選択がなされなかった旨を通知いたします。登録者は、その通知に記載されている期間内・方法等当社が定める条件に従って、商品選択を行うものとします。
          <br />
          ３．前項の通知に記載されている期間内に商品の選択が行われなかった場合、当社のシステムによる自動抽選により商品選択が行われるものとし、登録者はこれを承諾するものとします。なお、自動抽選によって選択された商品についても、第９条第１項に定める場合に限り返品又は交換を承ります。登録者が希望する商品でない等の自動抽選による商品選択を理由とするキャンセル、返品及び交換等はできません。
        </Content>

        <Content>
          第７条（商品の配送等）
          <br />
          １．商品等の配送は、当社が指定する配送業者により配送します。登録情報の誤記や不備などにより商品のお届けができない場合であっても、当社は一切の責任を負いません。
          <br />
          ２．登録者は、商品等の配送先として、日本国内の住所を指定するものとします。当該商品等にかかる配送料は、登録者のご負担となります。
          <br />
          ３．当社は、予め登録者に対してご案内した納期を変更できるものとします。また、品切れ等により注文に応じられない場合、当社は、決済を取消した上で、購入契約を解除できるものとします。
          <br />
          ４．前項の場合（キャンセルや返品及び交換等の対応が生じた場合を含みますが、これらに限りません。）でも、当社は何ら賠償の責任を負いません。
          <br />
          ５．登録者が、発送した商品を、当社が定める期限内に受領されなかった場合（受取拒否又は長期不在等により受け取られなかった場合を含みます。）、登録者はその商品に関する一切の権利を失うものとします。この場合、当社は当該商品を当社の任意の方法で処分できるものとし、一切返金を行わないものとします。
          <br />
          ６．前項の場合であっても、当社は、登録者の依頼に基づき、商品の再発送を行うことができます。再発送よって当社に生じた費用（再発送費用等）は、登録者が負担するものとします。
        </Content>

        <Content>
          第８条（決済方法）
          <br />
          １．本サービスの利用に関するお支払い金額は、くじの購入代金、送料及び消費税等の合計となります。
          <br />
          ２．本サービスによって購入されたくじのお支払いに関しては、登録者本人名義のクレジットカード（当社が承諾するものに限ります。）によるお支払い、その他当社が別途認めるお支払方法によるものとします。
          <br />
          ３．クレジットカードでのお支払いの場合は、登録者がカード会社との間で別途契約する条件に従うものとします。また、登録者と当該カード会社の間で紛争が発生した場合は、当該当事者双方で解決するものとし、当社は一切責任を負わないものとします。
          <br />
          ４．理由のいかんを問わず、クレジットカード会社等の決済代行事業者がクレジットカード等の登録者が指定した支払方法による決済を承認しなかった場合、登録者は、当該クレジットカード等を利用した決済を行うことができません。
          <br />
          ５．当社は、購入から商品発送までに一定の期間が経過した場合、クレジットカード会社等へクレジットカードの利用の可否を確認する場合があります。この際、クレジットカードの利用確認ができない場合、当社は、決済を取消した上で、購入契約を解除できるものとします。
        </Content>

        <Content>
          第９条（商品等の返品等）
          <br />
          １．購入契約成立後のキャンセル、商品等の発送キャンセル、返品及び交換、その他の対応（以下「キャンセル等」といいます。）は、商品不良、品違い又は数量違い等の当社の責めに帰すべき場合にのみ承ります。
          <br />
          ２．登録者は、前項のキャンセル等を、当社が別途定める方法に従い行うものとします。
        </Content>

        <Content>
          第１０条（サービスに関する免責）
          <br />
          １．商品等の色合い、形状については、モニターの設定等により、画面表示と実物とで異なる場合があります。
          <br />
          ２．当社は、本サービス上での商品説明等の表記について、正確かつ最新の情報を掲載するように努力いたしますが、一切誤りがないことを保証するものではありません。
          <br />
          ３．当社は、法律上の請求原因の如何を問わず、当社の故意又は重過失による場合を除き、本サービスの利用から生じる如何なる損害、損失、不利益に関して責任を負わないものとします。また、本サービスにおいて提供される商品等から生じた損害、損失、不利益に関して、当社の故意又は重過失による場合を除き、責任を負わないものとします。
        </Content>

        <Content>
          第１１条（特典）
          <br />
          登録者が「くじロード」内の個別のサービス・ページにて、くじを購入した場合において、当該くじとは別個に実施される自動抽選によって、購入したくじで得られる商品とは別の商品が当選する場合があります。
        </Content>

        <Content>
          第１２条（商品の破棄）
          <br />
          １．登録者は、購入契約の成立後に当選した商品について、当社が定める期間内に限り、当社が別途定める方法により、当該登録者が当選した商品の個数の範囲内で、提供を受ける商品の個数を変更することができます（以下、この仕組みによる個数の変更を「破棄」といいます。）。この場合、当社は、商品の破棄を行った登録者に対して、当社が別途定める条件に従ったポイントを付与することができます。なお、破棄は、当社が別途定める方法に従い、登録者自ら行ってください。
          <br />
          ２．前項に定める期間の経過後は、登録者は、提供を受ける商品の個数を変更することは一切できませんので予めご了承ください。
          <br />
          ３．破棄の撤回は、販売中、販売終了後を問わず、一切受け付けません。
          <br />
          ４．登録者が商品の破棄により提供を受ける商品の個数を変更した場合であっても、当社は、その変更分に関わるくじの代金を一切返金いたしません。
          <br />
          ５．前各項の定めにかかわらず、当社は、登録者が商品を破棄できないくじを販売することができます。購入の際には、くじの内容をよくご確認ください。
        </Content>

        <Content>
          第１３条（本サービスの利用停止、登録者登録の取消、ポイントの抹消）
          <br />
          １．当社は、登録者が以下の各号のいずれかに該当する場合、登録者に事前通知することなく本サービスの利用停止、登録者登録の取消又はポイントの一部若しくは全部を抹消することができるものとします。
          <br />
          （１）過去に本規約等に違反をしたこと等により登録者登録の取消等の処分をうけていることが判明した場合
          <br />
          （２）本サービスに関する料金等の支払債務の履行遅延、その他の不履行があった場合
          <br />
          （３）死亡又は行為能力を失った場合
          <br />
          （４）第１４条（禁止事項）の行為を行った場合
          <br />
          （５）その他本規約等に違反した場合
          <br />
          ２．前項により登録者の登録が取消された場合、当該登録者は、それ以降、本サービスを利用することができません。
        </Content>

        <Content>
          第１４条（禁止事項）
          <br />
          登録者は以下の行為を行ってはならないものとします。
          <br />
          （１）法令又は公序良俗に違反する行為
          <br />
          （２）本サービス利用の際に虚偽の登録内容を申請する行為
          <br />
          （３）本サービスの運営を妨げ、その他本サービスに支障をきたすおそれのある行為
          <br />
          （４）不正な手段を用いて本サービスを利用する行為
          <br />
          （５）第三者になりすます行為又は他のお客様のアカウントを使用する行為
          <br />
          （６）登録者のメールアドレス及びパスワードを不正に使用する行為
          <br />
          （７）法的な責任を超えた不当な要求行為
          <br />
          （８）他の登録者、第三者若しくは当社に迷惑、不利益若しくは損害を与える行為、又はそれらのおそれのある行為
          <br />
          （９）他の登録者、第三者若しくは当社の著作権等の知的財産権、プライバシーその他の権利を侵害する行為、又はそれらのおそれのある行為
          <br />
          （１０）本規約等に違反する行為、公序良俗に反する行為その他法令に違反する行為、又はそれらのおそれのあると当社が判断した行為
          <br />
          （１１）その他、当社が不適当と判断する行為
        </Content>

        <Content>
          第１５条（メールアドレス及びパスワードの管理）
          <br />
          １．登録者は、登録者メールアドレス及びパスワードの管理責任を負うものとします。
          また、登録者メールアドレス及びパスワードを用いて当社に対して行われた行為は、当該登録者メールアドレス及びパスワードに該当する登録者の有効な意思表示とみなし、これにより生ずる支払義務等は全て当該登録者の責任となります。
          <br />
          ２．登録者は、登録者メールアドレス及びパスワードを第三者に譲渡、貸与、開示してはならないものとします。
          <br />
          ３．登録者は、登録者メールアドレス及びパスワードの管理不十分、使用上の過誤、第三者の使用等に起因する損害につき自ら責任を負うものとします。
          <br />
          ４．登録者は、登録者メールアドレス及びパスワードが第三者によって不正に使用されていることが判明した場合には、直ちに当社に連絡するものとします。この場合、当社は当該登録者による本サービスの利用を停止することができるものとします。当社は、当該利用停止措置により登録者に生じた損害について一切の責任を負いません。
        </Content>

        <Content>
          第１６条（変更の届出）
          <br />
          １．登録者は、住所、氏名、電話番号、メールアドレス等の登録情報に変更があった場合、当社が別途定める方法により、直ちに当社に届け出るものとします。
          <br />
          ２．当社は、本サービスにおいて登録者に通知等を行う場合、登録情報に基づき通知等を行うものとし、当該通知が到達しなかった場合であっても、通常到達するであろう時をもって登録者に到達したものとみなします。
        </Content>

        <Content>
          第１７条（本サービス内容の変更、停止、終了等）
          <br />
          １．当社が必要と判断した場合には、登録者に事前に通知することなく、いつでも本サービス内容について変更することができ、又、ポイントの停止、若しくは中止、中断、終了、及び付与条件の変更等（以下「変更等」といいます。）を行うことができるものとします。但し、本サービスに関して登録者の権利や義務に重大な影響が生じる変更等については、合理的な予告期間を設けた上で、変更等を行うものとします。
          <br />
          ２．前項のような変更等を行った場合であっても、当社は登録者に対しては一切責任を負わないものとします。
          <br />
          ３．当社が必要と判断した場合には、本サイト上に告知することで、いつでも本サービスを廃止することができるものとします。
        </Content>

        <Content>
          第１８条（退会）
          <br />
          登録者は、登録者の都合により退会を希望する場合は、当社が別途定める方法により、いつでも利用契約を解約し、退会することができます。尚、未発送商品等がある場合は、当社による当該商品等の発送及びこれに対する登録者のお支払いを全て終えるまで、本規約等に基づく登録者の義務は存続するものとします。登録者メールアドレス、パスワードを忘れ、退会できない方は、当社所定の方法にてパスワードの再発行を受けるものとします。
        </Content>

        <Content>
          第１９条（解除）
          <br />
          １．当社は、登録者が次の各号のいずれか一つに該当したときは、催告を要せず、ただちに利用契約及び購入契約を解除することができることとします。
          <br />
          （１）本規約等に定める条項に違反し、相手方に対し催告したにもかかわらず１４日以内に当該違反が是正されないとき
          <br />
          （２）監督官庁より営業の許可取消し、停止等の処分を受けたとき
          <br />
          （３）支払停止若しくは支払不能の状態に陥ったとき、又は手形若しくは小切手が不渡りとなったとき
          <br />
          （４）第三者より差押え、仮差押え、仮処分若しくは競売の申立て、又は公租公課の滞納処分を受けたとき
          <br />
          （５）破産手続開始、民事再生手続開始、会社更生手続開始、特別清算手続開始の申立てを受け、又は自ら申立てを行ったとき
          <br />
          （６）解散、会社分割、事業譲渡又は合併の決議をしたとき
          <br />
          （７）資産又は信用状態に重大な変化が生じ、本規約等に基づく債務の履行が困難になるおそれがあると認められるとき
          <br />
          （８）その他、前各号に準じる事由が生じたとき
          <br />
          ２.　前項の場合、利用契約又は購入契約を解除された登録者は、当該解除によって、当社に生じた損害の一切を賠償するものとします。
        </Content>

        <Content>
          第２０条（契約終了後の処理）
          <br />
          １．登録者は、理由の如何を問わず、利用契約の終了と同時に、本サービスの利用を終了するものとし、以後、本サービスを利用することはできません。
          <br />
          ２．本サービスの提供を終了した後も、第３条第３項、第８条第３項、第９条第１項、第１０条、第１８条、第１９条第２項、本条、第２１条、第２２条、第２４条第３項、第２５条、第２８条、第３０条はその条件に従い有効に存続するものとします。
        </Content>

        <Content>
          第２１条（秘密保持）
          <br />
          登録者は、本サービスに関連して当社が開示した技術上、営業上及び業務上の一切の情報について、厳に秘密として保持し、第三者に漏洩又は開示してはならないものとします。
        </Content>

        <Content>
          第２２条（知的財産権）
          <br />
          １．本サービス及び本サービスを構成する文章、画像、プログラムその他のデータ等についての知的財産権（特許権、実用新案権、意匠権、商標権、著作権（著作権法第２７条及び第２８条に定める権利を含みます。）をいいます。）、知的財産権を受ける権利及びその他一切の権利は、全て当社又は当社にライセンスを許諾している者に留保されるものとします。
          <br />
          ２．登録者は、本サービスにおいて本規約等により認められた範囲で利用する場合を除き、本サービスを通じて提供される如何なる情報も、当社に無断で複製、複写、転載、転送、蓄積、販売等の方法により利用してはならないものとします。
        </Content>

        <Content>
          第２３条（個人情報）
          <br />
          当社は、本サービスの提供にあたり、個人情報の保護に関する法律（以下「個人情報保護法」といいます。）及び当社の「プライバシーポリシー」（{' '}
          <a href="https://bushiroad.co.jp/privacy" target="_blank">
            https://bushiroad.co.jp/privacy
          </a>{' '}
          ）に従って、個人情報（個人情報保護法において定義される「個人情報」をいいます。）を適正に取り扱うものとし、登録者はこれに同意するものとします。
        </Content>

        <Content>
          第２４条（その他免責事項）
          <br />
          １．当社は、以下の場合に一時的に本サービスの提供を停止、中止、中断等の措置を行うことがあります。これにより登録者が本サービスの全部又は一部をご利用になれず、登録者に損害が生じた場合においても、当社は当該損害について如何なる責任も負わないものとします。
          <br />
          （１）本サービスの障害、保守又はメンテナンスを緊急に行う必要がある場合
          <br />
          （２）天災地変、自然災害、停電等の当社の帰責事由によらず本サービスの運営が出来なくなった場合
          <br />
          （３）通信回線等の事故により本サービスが停止した場合
          <br />
          ２．当社は、登録者の登録情報に従い事務を処理することにより登録者に損害が生じても一切責任を負わないものとします。
          <br />
          ３．登録者が、本サービスをご利用になることにより、他の登録者又は第三者に対して損害等を与えた場合には、当該登録者は自己の責任と費用において解決し、当社には一切迷惑を与えないものとします。
        </Content>

        <Content>
          第２５条（損害賠償の範囲）
          <br />
          本規約等の他の規定にかかわらず、登録者による本サービスの利用に関し、当社が登録者に対して負うべき損害賠償責任の範囲は、登録者に現実に生じた、直接かつ通常の損害の範囲に限られるものとします。また、当該損害賠償責任の上限額は、当社の故意又は重過失による場合を除き、登録者が支払った対価の額を上限とします。
        </Content>

        <Content>
          第２６条（連絡方法）
          <br />
          登録者が、当社に対して連絡を行う場合、登録者は当社が別途定める方法により連絡するものとします。
        </Content>

        <Content>
          第２７条（本規約等の変更）
          <br />
          １．当社は、以下の場合で、かつ当社が必要と判断した場合には、登録者の同意を得ることなく本規約等の内容を変更することができるものとします。
          <br />
          （１）本規約等の変更が、登録者の一般の利益に適合する場合
          <br />
          （２）本規約等の変更が、契約をした目的に反せず、かつ、変更の必要性、変更後の内容の相当性、変更の内容その他の変更にかかる事情に照らして合理的なものである場合
          <br />
          ２．当社は、前項による本規約等の変更にあたり、本規約等を変更する旨、変更後の本規約等の内容及びその効力発生日を、当社のウェブサイトへ掲載する方法、個別に電子メールを送信する方法その他適切な方法により登録者に通知します。前項第２号に基づく変更を行う場合には、当社はその通知を、変更後の本規約等の効力発生日までに周知するものとします。
          <br />
          ３．変更後の本規約等の効力が生じた場合には、全ての登録者に対して、変更後の本規約等が適用されるものとします。
        </Content>
        <Content>
          第２８条（地位の譲渡等の禁止）
          <br />
          １．登録者は、当社の書面による事前の承諾なく、本サービス利用上の登録者としての地位及び権利義務について、第三者に対し、譲渡、担保設定その他の処分をすることができないものとします。
          <br />
          ２．当社が本サービスに係る事業を第三者に譲渡した場合には、当該事業譲渡に伴って、利用契約上の当社の地位及び権利義務並びに登録情報が当該事業譲渡の譲受人に承継されることにつき、登録者は、あらかじめ異議なく同意するものとします。なお、本項の「事業譲渡」には、会社法（平成１７年法律第８６号）第４６７条第１項第１号及び第２号に定める事業の譲渡のみならず、当社が消滅会社又は分割会社となる合併又は会社分割等による包括承継その他本サービスに係る事業が第三者に移転するあらゆる場合を含むものとします。
        </Content>
        <Content>
          第２９条（分離可能性）
          <br />
          本規約等のいずれかの条項又はその一部が、消費者契約法その他の法令等により無効とされた場合であっても、本規約等の残りの規定及び一部が無効と判断された規定の残りの部分は、継続して完全に効力を有するものとします。
        </Content>
        <Content>
          第３０条（準拠法及び合意管轄）
          <br />
          １．本サービス及び本規約等は、日本法に準拠して解釈されるものとします。
          <br />
          ２．本サービス及び本規約等において当社と登録者の間に紛争が発生した場合には、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
        </Content>

        <Content>2024年2月1日　制定</Content>
        <Content>2025年2月18日　改定</Content>
      </div>
      <ScrollButton />
    </>
  );
}
